// import CRMCustomerImg from "./CRMCustomer.png";
// import BIInsightImg from "./BIInsight.png";
import InventoryReturns from "./INVENTORY/Returns.js";
// import LogisticRoutesImg from "./LogisticRoutes.png";
// import LogisticScheduleImg from "./LogisticSchedule.png";
// import BIStrategiesImg from "./BIStrategies.png";
// import AccountingInvoiceImg from "./Accounting Invoice.png";
// import DropShipDocumentsImg from "./DropShipDocuments.png";
// import DropShipInvoiceImg from "./DropShipInvoice.png";
// import DropShipProductImg from "./DropShipProduct.png";
import LogisticsDashboard from "./Logistics/LogisticsDashboard";
import OMSOrderList from "./OMS/OMS order list";
import OMSPurchaseList from "./OMS/OMS Purchase";
import InventoryStockList from "./INVENTORY/InventoryStockList";
import OMSReturns from "./OMS/OMSReturns";
import OMSMarketPlace from "./OMS/OMSMarketPlace";
import InventoryPurchase from "./INVENTORY/InventoryPurchase";
import HRDashboard from "./HR/HRDashboard.js";
import OMSDashboard from "./OMS/OMSDashboard";
import InventoryDashboard from "./INVENTORY/InventoryDashboard";
import WarehouseDashboard from "./WAREHOUSE/WarehouseDashboard";
import DropshippingDashboard from "./DROPSHIPPING/DropshippingDashboard";
import CRMDashboard from "./CRM/CRMDashboard";
import HREmployee from "./HR/HREmployee";
import HRTeams from "./HR/HRTeams";
import HRPayroll from "./HR/HRPayroll";
import HRRecruitment from "./HR/HRRecruitment";
import WarehouseProducts from "./WAREHOUSE/Products.js";
import WarehouseSuppliers from "./WAREHOUSE/Suppliers.js";
import WarehouseDetails from "./WAREHOUSE/WarehouseDetails.js";
import FinanceDashBoard from "./FINANCE/FinanceDashboard";
import FinanaceExpenditute from "./FINANCE/Expenditure";
import BIinsightsData from "./BI/BIinsightsData";
import BIDashboard from "./BI/BIDashboard";
import BIstrastegies from "./BI/BIstrastegies";
import Notess from "./Profile/notess.js";
import Task from './Profile/task.js'
import BasicInfo from "./Setting/basicInfo.js";

import AccDashboard from "./ACCOUNT/AccDashboard.js";
import AccAccount from "./ACCOUNT/AccAccount.js";
import AccInvoice from "./ACCOUNT/AccInvoice.js";

import CRMCampaigns from "./CRM/CRMCampaigns";
import CRMCustomers from "./CRM/CRMCustomers";
import CRMTeams from "./CRM/CRMTeams";
import General from "./SETTINGS/General.js";
import Subscriptions from "./SETTINGS/Subscriptions.js";
import Plans from "./SETTINGS/Plans.js";
import ProfileDash from "./Profile/ProfileDash.js";

import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import InventoryOutlinedIcon from '@mui/icons-material/InventoryOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import UTurnLeftOutlinedIcon from '@mui/icons-material/UTurnLeftOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import GroupAddOutlinedIcon from '@mui/icons-material/GroupAddOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import LanOutlinedIcon from '@mui/icons-material/LanOutlined';
import SwapCallsOutlinedIcon from '@mui/icons-material/SwapCallsOutlined';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import TimelineOutlinedIcon from '@mui/icons-material/TimelineOutlined';
import TipsAndUpdatesOutlinedIcon from '@mui/icons-material/TipsAndUpdatesOutlined';
import RouteIcon from '@mui/icons-material/Route';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import PendingActionsOutlinedIcon from '@mui/icons-material/PendingActionsOutlined';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';


const OMSSubbarData = [
  {
    click: OMSDashboard,
    icon: <GridViewOutlinedIcon/>,
    name: "Dashboard",

  },
  {
    click: OMSOrderList,
    icon:<InventoryOutlinedIcon/>,
    name: "Order List",
  },
  {
    click: OMSPurchaseList,
    icon:<ShoppingCartOutlinedIcon/>,
    name: "Purchase",
  },
  {
    click: OMSReturns,
    icon:<UTurnLeftOutlinedIcon/>,
    name: "Returns",
  },
  {
    click: OMSMarketPlace,
    icon:<StorefrontOutlinedIcon/>,
    name: "Marketplace",
    id:''
  },
];

const InventorySubbarData = [
  {
    click: InventoryDashboard,
    icon: <GridViewOutlinedIcon/>,
    name: "Dashboard",
  },
  {
    click: InventoryStockList,
    icon:<InventoryOutlinedIcon/>,
    name: "Stock List",
  },
  {
    click: InventoryPurchase,
    icon:<ShoppingCartOutlinedIcon/>,
    name: "Purchase",
  },
  {
    click: InventoryReturns,
    icon:<UTurnLeftOutlinedIcon/>,
    name: "Returns",
  },
];

const WarehouseSubbarData = [
  {
    click: WarehouseDashboard,
    icon: <GridViewOutlinedIcon/>,
    name: "Dashboard",
  },
  {
    click: WarehouseDetails,
    icon:<InventoryOutlinedIcon/>,
    name: "Warehouse Details",
  },
  {
    click: WarehouseProducts,
    icon:<LanOutlinedIcon/>,
    name: "Products",
  },
  {
    click: WarehouseSuppliers,
    icon:<StorefrontOutlinedIcon/>,
    name: "Suppliers",
  },
];
const HRSubbarData = [
  {
    click: HRDashboard,
    icon: <GridViewOutlinedIcon/>,
    name: "Dashboard",
  },
  {
    click: HREmployee,
    icon:<BadgeOutlinedIcon/>,
    name: "Employees",
  },
  {
    click: HRTeams,
    icon:<GroupsOutlinedIcon/>,
    name: "Teams",
  },
  {
    click: HRPayroll,
    icon:<PaymentsOutlinedIcon/>,
    name: "Payroll",
  },
  {
    click: HRRecruitment,
    icon:<GroupAddOutlinedIcon/>,
    name: "Recruitment",
  },
];
const CRMSubbarData = [
  {
    click: CRMDashboard,
    icon: <GridViewOutlinedIcon/>,
    name: "Dashboard",
  },
  {
    click: CRMCampaigns,
    icon:<CampaignOutlinedIcon/>,
    name: "Campaigns",
  },
  {
    click: CRMCustomers,
    icon:<BadgeOutlinedIcon/>,
    name: "Customers",
  },
  {
    click: CRMTeams,
    icon:<GroupsOutlinedIcon/>,
    name: "Teams",
  },
];

const DropShipSubbarData = [
  {
    click: DropshippingDashboard,
    icon: <GridViewOutlinedIcon/>,
    name: "Dashboard",
  },
  {
    click: "",
    icon:<Inventory2OutlinedIcon/>,
    name: "Products",
  },
  {
    click: "",
    icon:<LocalShippingOutlinedIcon/>,
    name: "Shipments",
  },
  {
    click: "",
    icon:<LanOutlinedIcon/>,
    name: "Customers",
  },
  {
    click: "",
    icon:<SwapCallsOutlinedIcon/>,
    name: "Suppliers",
  },
  {
    click: "",
    icon:<ContentCopyOutlinedIcon/>,
    name: "Documents",
  },
  {
    click: "",
    icon:<ReceiptLongOutlinedIcon/>,
    name: "Invoices",
  },
];
const FinanceSubbarData = [
  {
    click: FinanceDashBoard,
    icon: <GridViewOutlinedIcon/>,
    name: "Dashboard",
  },
  {
    click: FinanaceExpenditute,
    icon:<InventoryOutlinedIcon/>,
    name: "Expenditure",
  },
];

const AccountingSubbarData = [
  {
    click: AccDashboard,
    icon: <GridViewOutlinedIcon/>,
    name: "Dashboard",
  },
  {
    click: AccAccount,
    icon:<AccountBalanceOutlinedIcon/>,
    name: "Accounts",
  },
  {
    click: AccInvoice,
    icon:<ReceiptLongOutlinedIcon/>,
    name: "Invoices",
  },
];

// const AccountingSubbarData = [
//   { click: "",
//   // img: dashboardImg,
//   name: "Dashboard" },
//   { click: "",
//   // img: "",
//    name: "Accounts" },
//   { click: "",
//   //  img: AccountingInvoiceImg,
//     name: "Invoices" },
// ];
const BISubbarData = [
  {
    click: BIDashboard,
    icon: <GridViewOutlinedIcon/>,
    name: "Dashboard",
  },
  {
    click: BIinsightsData,
    icon:<TimelineOutlinedIcon/>,
    name: "Insights",
  },
  {
    click: BIstrastegies,
    icon:<TipsAndUpdatesOutlinedIcon/>,
    name: "Strategies",
  },
];
const LogisticSubbarData = [
  {
    click: LogisticsDashboard,
    icon: <GridViewOutlinedIcon/>,
    name: "Dashboard",
  },
  {
    click: "",
    icon:<ReceiptOutlinedIcon/>,
    name: "Payments",
  },
  {
    click: "",
    icon:<RouteIcon/>,
    name: "Routes",
  },
  {
    click: "",
    icon:<PendingActionsOutlinedIcon/>,
    name: "Schedule",
  },
  {
    click: "",
    icon:<StorefrontOutlinedIcon/>,
    name: "Shipment Management",
  },
];

const SettingSubbarData = [
  {
    click: General,
    icon:<TuneOutlinedIcon/>,
    name: "General",
  },
  {
    click: Subscriptions,
    icon:<PaymentsOutlinedIcon/>,
    name: "Subscriptions",
  },
  {
    click: Plans,
    icon:<DescriptionOutlinedIcon/>,
    name: "Plans",
  },
];
const SettingSetSubbarData = [
  {
    click: BasicInfo,
    icon:<TuneOutlinedIcon/>,
    name: "Basic Info",
  },
  {
    click: Subscriptions,
    icon:<PaymentsOutlinedIcon/>,
    name: "Roles",
  },
  {
    click: Plans,
    icon:<DescriptionOutlinedIcon/>,
    name: "Autorisations",
  },
  {
    click: General,
    icon:<TuneOutlinedIcon/>,
    name: "Teams Info",
  },
  {
    click: Subscriptions,
    icon:<PaymentsOutlinedIcon/>,
    name: "Templates",
  },
];

const ProfileSubbarData = [
  {
    click: ProfileDash ,
    icon:<TuneOutlinedIcon/>,
    name: "Dashboard",
  },
  {
    click: Subscriptions,
    icon:<PaymentsOutlinedIcon/>,
    name: "Messages",
  },
  {
    click: Plans,
    icon:<DescriptionOutlinedIcon/>,
    name: "Calender",
  },
  {
    click: Task,
    icon:<TuneOutlinedIcon/>,
    name: "Tasks",
  },
  {
    click: Notess,
    icon:<PaymentsOutlinedIcon/>,
    name: "Notes",
  },
  {
    click: Plans,
    icon:<DescriptionOutlinedIcon/>,
    name: "Plans",
  },
  {
    click: Plans,
    icon:<DescriptionOutlinedIcon/>,
    name: "Teams",
  },
];

export { OMSSubbarData };
export { InventorySubbarData };
export { WarehouseSubbarData };
export { HRSubbarData };
export { CRMSubbarData };
export { DropShipSubbarData };
export { FinanceSubbarData };
export { AccountingSubbarData };
export { BISubbarData };
export { LogisticSubbarData };
export { SettingSubbarData };
export { ProfileSubbarData };
export { SettingSetSubbarData }
